const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

function isPrivateIpv4(hostname) {
  const octets = String(hostname || "")
    .split(".")
    .map(Number);
  if (octets.length !== 4 || octets.some((item) => !Number.isInteger(item) || item < 0 || item > 255)) {
    return false;
  }

  return (
    octets[0] === 10 ||
    octets[0] === 127 ||
    (octets[0] === 169 && octets[1] === 254) ||
    (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) ||
    (octets[0] === 192 && octets[1] === 168)
  );
}

function isLocalNetworkHostname(hostname) {
  return LOCAL_HOSTNAMES.has(String(hostname || "").toLowerCase()) || isPrivateIpv4(hostname);
}

export function resolveBackendUrl(
  configuredUrl,
  {
    pageOrigin = typeof window !== "undefined" ? window.location.origin : "",
    isProduction = process.env.NODE_ENV === "production",
  } = {},
) {
  const fallback = pageOrigin || "http://localhost:8000";
  if (!configuredUrl) {
    return fallback.replace(/\/+$/, "");
  }

  try {
    const configured = new URL(configuredUrl, fallback);
    const page = new URL(fallback);
    const publicProductionPage =
      isProduction && !isLocalNetworkHostname(page.hostname);
    const unsafeProductionTarget =
      isLocalNetworkHostname(configured.hostname) ||
      (page.protocol === "https:" && configured.protocol !== "https:");

    if (publicProductionPage && unsafeProductionTarget) {
      return page.origin;
    }

    return configured.toString().replace(/\/+$/, "");
  } catch (_error) {
    return fallback.replace(/\/+$/, "");
  }
}
